export enum actionTypes {
    NOTIFICATION = "notification"
}
